<template>
  <div class="inputFormStyle">
    <v-container class="pa-0">
      <v-row :v-if="heading" no-gutters>
        <v-col>
          <span class="headingStyle primary--text">{{ $t(heading) }} </span>
        </v-col>
      </v-row>
      <v-row
        :style="'max-height:' + rowHeight"
        class="align-center my-4"
        v-for="(rec, index) in detail"
        :key="index"
        no-gutters
      >
        <v-col :cols="titleCols">
          {{ rec.text }}<RequiredLabel v-if="rec.required ? true : false" />
        </v-col>
        <v-col :cols="rec.cols ? rec.cols : contentsCols">
          <slot :name="rec.name" v-bind:item="dataList">
            <PhoneNumberInput
              v-if="rec.type === 'phone'"
              v-model="dataList[rec.name]"
            />
            <NormalDatePicker
              v-else-if="rec.type === 'calendar'"
              width="100%"
              v-model="dataList[rec.name]"
            />

            <FromToDatePicker
              v-else-if="rec.type === 'fromToCalendar'"
              v-model="dataList[rec.name]"
            />

            <span v-else-if="rec.type === 'supplierNameAndCurrency'">
              <v-row>
                <v-col class="6">
                  <!-- 仕入先名 -->
                  <SelectSupplierName v-model="dataList[rec.name]" />
                </v-col>
                <v-col cols="6">
                  <v-row no-gutters>
                    <v-col cols="4" class="originalCenter"
                      >{{ $t('common.input_currency') }}
                    </v-col>
                    <v-col>
                      <!-- 通貨 -->
                      <SelectCurrency v-model="dataList[rec.name]" />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </span>

            <span v-else-if="rec.type === 'orderInfo'">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="dataList[rec.name]"
                    :placeholder="$t('common.input_input_1')"
                    outlined
                    dense
                    hide-details
                    :height="inputItemHeight"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </span>

            <span v-else-if="rec.type === 'productNoAndProductCategory'">
              <v-row>
                <v-col class="6">
                  <!-- 商品番号 -->
                  <v-text-field
                    v-model="dataList[rec.name]"
                    outlined
                    dense
                    hide-details
                    :placeholder="$t('common.product_product-number')"
                    :height="inputItemHeight"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <!-- 商品カテゴリ -->
                  <SelectProductCategory v-model="dataList[rec.name]" />
                </v-col>
              </v-row>
            </span>

            <v-text-field
              v-else
              v-model="dataList[rec.name]"
              :placeholder="$t('common.input_input_1')"
              outlined
              dense
              hide-details
              :height="inputItemHeight"
            >
            </v-text-field>
          </slot>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import NormalDatePicker from '@/components/items/inputs/NormalDatePicker'
import FromToDatePicker from '@/components/items/inputs/FromToDatePicker'

import PhoneNumberInput from '@/components/items/inputs/PhoneNumberInput'
import RequiredLabel from '@/components/items/Labels/RequiredLabel'

export default {
  components: {
    RequiredLabel,
    PhoneNumberInput,
    NormalDatePicker,
    FromToDatePicker
  },
  props: {
    heading: {
      type: String,
      require: false,
      default: ''
    },
    detail: {
      type: Array,
      require: true,
      default: () => []
    },
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    rowHeight: {
      type: String,
      require: false,
      default: ''
    },
    inputItemHeight: {
      type: String,
      require: false,
      default: ''
    },
    titleCols: {
      type: Number,
      require: false,
      default: 6
    },
    contentsCols: {
      type: Number,
      require: false,
      default: 6
    }
  },
  data: () => ({ items: [] }),
  created() {
    this.items = this.getCountryCode()
  },
  methods: {
    getCountryCode() {
      return [{ label: '+81', value: 1 }]
    }
  },
  computed: {
    dataList: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inputFormStyle {
  width: 100%;
  height: 100%;
  font-size: 14px;
}
.headingStyle {
  font-size: 16px;
  font-weight: bold;
}
</style>
